import { cellStickPositionFinder } from "./TableUtils";
import BodyEditCell from "./BodyEditCell";
import { flexRender } from "@tanstack/react-table";
import ActionsCell from "./ActionsCell";

const BodyCell = (props) => {
  const { stickPosition, cell, table, rowState, row } = props;
  const { dropdowns, setDropdowns } = rowState;
  const { id: columnId } = cell.column.columnDef;
  const isEditCell = columnId === "edit";
  const isCellEditable = cell.column.columnDef.isEditable && !isEditCell;

  return (
    <td
      key={cell.row.id + columnId}
      style={{
        ...cellStickPositionFinder(stickPosition),
        zIndex: stickPosition !== "" ? 9 : 8,
      }}
      className='live-view-body-cell-container'
    >
      <div
        style={{
          width: columnId === "edit" ? "8rem" : "11rem",
          borderLeft: columnId === "edit" ? "2px solid silver" : "",
          borderRight: stickPosition === "left" ? "2px solid silver" : "",
        }}
        className='live-view-body-cell'
      >
        {isCellEditable ? (
          <BodyEditCell
            column={cell.column}
            row={cell.row}
            table={table}
            rowState={rowState}
            getValue={cell.getValue}
            cell={cell}
            dropdowns={dropdowns}
            setDropdowns={setDropdowns}
          />
        ) : (
          <ActionsCell table={table} row={row} rowState={rowState} />
        )}
      </div>
    </td>
  );
};

export default BodyCell;
